import React from "react";
import { ButtonSelect, ButtonSelectOption } from "./button-select";
import { InteractiveTextLink } from "./interactive-text-link";

interface FilterChipRowProps<Id extends string> {
    label: string;
    options: ButtonSelectOption<Id>[];
    selectedIds: Id[];
    onToggle: (id: Id) => void;
    onClear: () => void;
    trailing: React.ReactNode;
}

export const FilterChipRow = <Id extends string>(
    props: FilterChipRowProps<Id>,
): React.ReactElement => (
    <div className="flex flex-wrap items-center gap-x-2">
        <span className="text-xs font-medium text-gray-500">{props.label}</span>
        <ButtonSelect
            options={props.options}
            selectedIds={props.selectedIds}
            onToggle={props.onToggle}
        />
        {props.trailing}
        {props.selectedIds.length > 0 ? (
            <InteractiveTextLink className="text-sm" onClick={props.onClear}>
                Clear filter
            </InteractiveTextLink>
        ) : null}
    </div>
);
